module.exports = __webpack_public_path__ + "img/286-ab9ca1.png";